'use client';

import { useTranslations } from 'next-intl';

import { type IDramaInfo } from '@/apis/search';
import InfiniteScrollList from '@/components/infinite-scroll-list';

import SearchCardItem from './search-card-item';

interface ICardListProps {
    loading: boolean;
    hasMore: boolean;
    keyword: string;
    searchId: string;
    cardList: IDramaInfo[];
    onCardClick: (item: IDramaInfo) => void;
    onLoadMore: () => Promise<void>;
}

export default function CardList(props: ICardListProps) {
    const t = useTranslations('Discover');
    const { loading, hasMore, cardList, onCardClick, onLoadMore, keyword, searchId } = props;

    if (loading && cardList.length === 0) {
        return <div className='text-[12px] leading-[16px] text-[#888]'>{t('search_loading')}</div>;
    }

    if (cardList.length === 0) {
        return (
            <div className='flex justify-center pt-[40px] text-center text-[14px] leading-[20px] text-[#888]'>
                {t('search_no_result')}
            </div>
        );
    }

    return (
        <div className='space-y-[12px]'>
            {cardList.map((item, index) => (
                <SearchCardItem
                    key={item.drama_id}
                    item={item}
                    position={index + 1}
                    onClick={onCardClick}
                    keyword={keyword}
                    searchId={searchId}
                />
            ))}
            <InfiniteScrollList loadMore={onLoadMore} hasMore={hasMore} />
        </div>
    );
}
